const firebaseConfig = {
    apiKey: "AIzaSyARqoZJ85_gHXuovioKc9GGr5nmFA77f3Q",
    authDomain: "red-onion-restaurant-76e92.firebaseapp.com",
    projectId: "red-onion-restaurant-76e92",
    storageBucket: "red-onion-restaurant-76e92.appspot.com",
    messagingSenderId: "824642539410",
    appId: "1:824642539410:web:af617df498643bdf74bb4b"
};

export default firebaseConfig;